import React from "react";

const Card = ({ title, icon, data }) => {
  return (
    <div className="font-poppins col-span-1 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-md p-4 flex flex-col justify-center items-center h-full font-poppins">
      {icon && <div className="mb-4 text-4xl text-blue-500">{icon}</div>}
      <h3 className=" font-semibold text-gray-900 dark:text-white text-xl">
        {title}
      </h3>
      {data && (
        <p
          className={`text-xl mt-4 ${
            data === "Epuisé"
              ? "text-red-500"
              : "text-gray-600 dark:text-gray-400"
          }`}>
          {data}
        </p>
      )}
    </div>
  );
};

export default Card;
